import { render } from "./PreviewTipTap2.vue?vue&type=template&id=ef92fde2"
import script from "./PreviewTipTap2.vue?vue&type=script&lang=js"
export * from "./PreviewTipTap2.vue?vue&type=script&lang=js"

import "./PreviewTipTap2.vue?vue&type=style&index=0&id=ef92fde2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__